import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';

import { mergeDeep } from '@/_shared';

import { defaultValues } from './model';

import type { ContactFormSchema } from '../schemas';
import { contactFormSchema } from '../schemas';

export function useFormDefinition(v: Partial<ContactFormSchema> = {}) {
  return useForm({
    resolver: zodResolver(contactFormSchema),
    defaultValues: mergeDeep({ ...defaultValues }, v),
    shouldFocusError: true,
  });
}
